// extracted by mini-css-extract-plugin
export default {"PharmacyPanelContainer":"h5Ls6vHc","PharmacyPageCenterText":"IBkZ5_RR"};